import { render, staticRenderFns } from "./ProdutoCarrinhoBtnItj.vue?vue&type=template&id=61f86c02&scoped=true"
import script from "./ProdutoCarrinhoBtnItj.vue?vue&type=script&lang=js"
export * from "./ProdutoCarrinhoBtnItj.vue?vue&type=script&lang=js"
import style0 from "./ProdutoCarrinhoBtnItj.vue?vue&type=style&index=0&id=61f86c02&prod&lang=css"
import style1 from "./ProdutoCarrinhoBtnItj.vue?vue&type=style&index=1&id=61f86c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f86c02",
  null
  
)

export default component.exports